__turbopack_context__.v({
  "backLink": "login-module__Si-P0q__backLink",
  "btnRegister": "login-module__Si-P0q__btnRegister",
  "btnSpinner": "login-module__Si-P0q__btnSpinner",
  "btnSubmit": "login-module__Si-P0q__btnSubmit",
  "card": "login-module__Si-P0q__card",
  "cardHeader": "login-module__Si-P0q__cardHeader",
  "cardSubtitle": "login-module__Si-P0q__cardSubtitle",
  "cardTitle": "login-module__Si-P0q__cardTitle",
  "cardWrapper": "login-module__Si-P0q__cardWrapper",
  "divider": "login-module__Si-P0q__divider",
  "dividerLine": "login-module__Si-P0q__dividerLine",
  "dividerText": "login-module__Si-P0q__dividerText",
  "errorBanner": "login-module__Si-P0q__errorBanner",
  "eyeBtn": "login-module__Si-P0q__eyeBtn",
  "fadeUp": "login-module__Si-P0q__fadeUp",
  "fieldGroup": "login-module__Si-P0q__fieldGroup",
  "forgotLink": "login-module__Si-P0q__forgotLink",
  "formRow": "login-module__Si-P0q__formRow",
  "input": "login-module__Si-P0q__input",
  "inputWrap": "login-module__Si-P0q__inputWrap",
  "label": "login-module__Si-P0q__label",
  "logoWrap": "login-module__Si-P0q__logoWrap",
  "page": "login-module__Si-P0q__page",
  "rememberCheckbox": "login-module__Si-P0q__rememberCheckbox",
  "rememberLabel": "login-module__Si-P0q__rememberLabel",
  "spinIcon": "login-module__Si-P0q__spinIcon",
  "successBanner": "login-module__Si-P0q__successBanner",
  "svgConstellation": "login-module__Si-P0q__svgConstellation",
  "svgGeometry": "login-module__Si-P0q__svgGeometry",
});
